import type { Size } from './markupGeometry.ts';

export interface ExportSize extends Size {
    // Applied to the image and every shape alike, so marks keep their place.
    scale: number;
}

export const MAX_EXPORT_LONG_EDGE = 2000;

export function computeExportSize(image: Size, maxLongEdge = MAX_EXPORT_LONG_EDGE): ExportSize {
    const longEdge = Math.max(image.width, image.height);
    const scale = longEdge > maxLongEdge ? maxLongEdge / longEdge : 1;
    return {
        scale,
        width: Math.max(1, Math.min(maxLongEdge, Math.round(image.width * scale))),
        height: Math.max(1, Math.min(maxLongEdge, Math.round(image.height * scale)))
    };
}
